import { render, staticRenderFns } from "./PropertyTitle.vue?vue&type=template&id=4db20d32&"
import script from "./PropertyTitle.vue?vue&type=script&lang=js&"
export * from "./PropertyTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports